module.exports = __webpack_public_path__ + "media/images/forms-icons/text-area-icon-9c2a52768e4f3f55162362f3dcb8c7af.svg";